import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, formatDate, SubmitButton, formatDateTime, IconButton } from "../../Components/InputElements";
import axios from 'axios';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import { NoRecords } from '../../Components/Shimmer';
import { decodeData } from '../../Constants/constants';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';

import Swal from 'sweetalert2';
import { currentDateAndTime } from '../../Constants/constants';
import LeaveGeneralSettingsView from './LeaveGeneralSettingsView';
import { toHaveDisplayValue } from '@testing-library/jest-dom/matchers';
// import {getUpdatedFields } from '../../Constants/constants';
// import TooltipComponent from '../../Components/TooltipComponent';
import { validateDateOnly } from '../../Constants/constants';
import { formatDateTimeSafe } from '../../Constants/constants'


class AllLogs extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            calendar_id: 0,
            pms_cycle_id: 0,
            from_date: "",
            to_date: "",
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            loadingDelete: false,
            postLoading: false,
            errors: {},
            decodedData: [],
            logs:[],
            auditLogs:[],
            keyword: "",
            module_name: "",
            form_name: "",
            transaction_type: "",
            loading: true,
            prevInfo: false,
            updatedInfo: false,   
            LeaveGeneralSettingsView: false,       
            prev_info: false,       
            updated_info: false,       
        };
    }
    GetAuditLogs = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
     
        axios
          .get(`${apiURL}Masters/GetAuditLogs`, {  
            params: {
              limit: this.state.limit,
              page: this.state.page,
              keyword: this.state.keyword,
              module_name: this.state.module_name,
              form_name: this.state.form_name,
              transaction_type: this.state.transaction_type,
              from_date: this.state.from_date,
              to_date: this.state.to_date,
              company_id: this.state.company_id,
            },
            headers,
          })
          .then((response) => {
            console.log("Audit Log Response:", response.data);
    
            if (response.data.success) {
              this.setState({
                auditLogs: response.data.data || [],  
                next: response.data.next || null,
                prev: response.data.prev || null,
                page: response.data.page || 1,
                total_records: response.data.total_records || 0,
                total_pages: response.data.total_pages || 1,
                loadingList: false,
                loadingSearch: false,
                loadingFilter: false,
              });
            } else {
              this.setState({
                auditLogs: [], 
                loadingList: false,
                loadingSearch: false,
                loadingFilter: false,
              });
            }
          })
          .catch((error) => {
            console.error("Error fetching audit logs:", error);
            this.setState({
              auditLogs: [],
              loadingList: false,
              loadingSearch: false,
              loadingFilter: false,
            });
          });
    };
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
           
            this.GetAuditLogs();
        })
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }
    handleInputChange = (e) => {
        const { name, value } = e.target;

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };
    handleInputSearch = () => {
        this.GetAuditLogs();
      }
  
      handleClearAll = () => {
        this.setState(
          {
            location_id: "",
            department_id: "",
            location_shift_id: "",
            reporting_manager_employee_id: "",
            keyword: "",
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            postLoading: false,
            from_date: "",
            to_date: "",
            pms_cycle_id:
              this.state.auditLogs.length > 0 &&
              this.state.auditLogs[0]?.value,
            goal_status_filter: "",
            
          },
          () => {
            
            this.GetAuditLogs()
          }
        );
      };

 

   

  

 

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetAuditLogs();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetAuditLogs();
            });
        }
    }
    handleChange = (e) => {

        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetAuditLogs();
        });
    }

    
    handleLimitChange = (e) => {
        this.setState(
          {
            limit: parseInt(e.target.value, 10),
            page: 1,
          },
          () => {
            this.GetAuditLogs();
          }
        );
      };
      handleCSVDownload = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
    
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    
        axios
            .get(`${apiURL}Masters/GetAuditLogs`, {
                params: {
                    limit: this.state.limit,
                    page: this.state.page,
                    keyword: this.state.keyword,
                    module_name: this.state.module_name,
                    form_name: this.state.form_name,
                    transaction_type: this.state.transaction_type,
                    from_date: this.state.from_date,
                    to_date: this.state.to_date,
                    company_id: this.state.company_id,
                    date: currentDateAndTime(),
                },
                headers,
            })
            .then((response) => {
                if (response.data.success === true) {
                    const rows = response.data.data;
                    const csvData = rows.map(row => ({
                        'Module Name': row.module_name,
                        'Form Name': row.form_name,
                        'Transaction Type': row.transaction_type,
                        'Previous Information': row.previouse_information,
                        'After Information': row.updated_information,
                        'Entered by': row.created_by_name,
                        'Entered by Date & Time': row.created_date,
                    }));
    
                    const csv = Papa.unparse(csvData);
                    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.setAttribute('href', url);
                    link.setAttribute('download', `AuditLogReport_${new Date().toISOString()}.csv`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
    
                    Swal.close();
                    Swal.fire({
                        title: '<strong>Success</strong>',
                        html: 'Your file has been downloaded successfully.',
                        icon: 'success'
                    });
                } else {
                    Swal.close();
                    Swal.fire({
                        title: '<strong>Error</strong>',
                        html: response.data.message,
                        icon: 'error'
                    });
                }
            })
            .catch((error) => {
                Swal.close();
                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error'
                });
            });
    };
     handleExcelDownload = () => {
            const { apiURL, apiHeaderJSON } = this.context;
            const headers = apiHeaderJSON;
    
            Swal.fire({
                title: 'Please wait...',
                html: 'Your file is being prepared for download.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
    
            axios
          .get(`${apiURL}Masters/GetAuditLogs`, {  
            params: {
              limit: this.state.limit,
              page: this.state.page,
              keyword: this.state.keyword,
              module_name: this.state.module_name,
              form_name: this.state.form_name,
              transaction_type: this.state.transaction_type,
              from_date: this.state.from_date,
              to_date: this.state.to_date,
              company_id: this.state.company_id,
              date: currentDateAndTime(),
            },
            headers,
          }).then((response) => {
                if (response.data.success === true) {
                    const rows = response.data.data;
    
                    const data = rows.map(row => ({
                        'Module Name': row.module_name,
                        'Form Name': row.form_name,
                        'Transaction Type': row.transaction_type,
                        'Previous Information': row.previouse_information,
                        'After Information': row.updated_information,
                        'Entered by': row.created_by_name,
                        'Entered by Date & Time': row.created_date,
                        // 'Check by': row.checked_by,
                        // 'Check by Date & Time': row.checked_date,
                    }));
    
                    const columns = [
                        { header: 'Module Name', key: 'Module Name', width: 30 },
                        { header: 'Form Name', key: 'Form Name', width: 30 },
                        { header: 'Transaction Type', key: 'Transaction Type', width: 20 },
                        { header: 'Previous Information', key: 'Previous Information', width: 30 },
                        { header: 'After Information', key: 'After Information', width: 30 },
                        { header: 'Entered by', key: 'Entered by', width: 20 },
                        { header: 'Entered by Date & Time', key: 'Entered by Date & Time', width: 20 },
                        // { header: 'Check by', key: 'Check by', width: 20 },
                        // { header: 'Check by Date & Time', key: 'Check by Date & Time', width: 20 },
                        
                    ];
    
                    const wb = XLSX.utils.book_new();
    
                    const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });
    
                    ws['!cols'] = columns.map(column => ({ wch: column.width }));
    
                    XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });
    
                    columns.forEach((column, index) => {
                        ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
                    });
    
                    XLSX.utils.book_append_sheet(wb, ws, 'AbStart Attendance Report');
    
                    // XLSX.writeFile(wb, `AbStartTeamAttendanceReport_(${Date()}).xlsx`);
    
                    const date = new Date();
                    const dateString = date.toLocaleDateString();
                    const timeString = date.toLocaleTimeString();
    
                    XLSX.writeFile(wb, `AuditLogReport_(${formatDate(dateString)} ${timeString}).xlsx`);
    
                    Swal.close();
    
                    Swal.fire({
                        title: '<strong>Success</strong>',
                        html: 'Your file has been downloaded successfully.',
                        icon: 'success'
                    });
                } else {
                    Swal.close();
                    Swal.fire({
                        title: '<strong>Error</strong>',
                        html: response.data.message,
                        icon: 'error'
                    });
                }
            })
                .catch((error) => {
                    Swal.close();
                    Swal.fire({
                        title: '<strong>Error</strong>',
                        html: error.message,
                        icon: 'error'
                    });
                });
        }
    //  getUpdatedFields = (prevInfo, updatedInfo) => {
    //     try {
    //       const prevObj = JSON.parse(prevInfo);
    //       const updatedObj = JSON.parse(updatedInfo);
      
    //       const changes = {};
    //       Object.keys(updatedObj).forEach((key) => {
    //         if (prevObj[key] !== updatedObj[key]) {
    //           changes[key] = {
    //             old: prevObj[key] ?? "N/A",
    //             new: updatedObj[key] ?? "N/A"
    //           };
    //         }
    //       });
      
    //       return changes;
    //     } catch (error) {
    //       console.error("Error parsing JSON:", error);
    //       return {};
    //     }
    //   };

    handleClose=(formName)=>{
      if(formName==="LeaveGeneralSettingsView"){
        this.setState({ LeaveGeneralSettingsView:false });
      }
      this.setState({
        prev_info:"",
        updated_info: "",
      })
    }
    handleShow=(formName,previousInfo,updatedInfo)=>{
      if(formName==="Leave General Settings"){
        this.setState({ LeaveGeneralSettingsView:true });
      }
      this.setState({
        prev_info: previousInfo,
        updated_info: updatedInfo,
      })
    }
    
    render() {
        const { errors } = this.state;
        const limitOptions = [10, 25, 50, 100, 200, 500];
        // const updatedFields = getUpdatedFields(previousInfo, updatedInfo);
        return (
              <div className="main-content">
                    <div className="page-content">
                      <div className="container-fluid">
                        <br />
                        <PageTitle title={`All Logs`} primary={`Home`}/>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="card">
                              {this.state.LeaveGeneralSettingsView && (
                                <LeaveGeneralSettingsView prevInfo={this.state.prev_info} updatedInfo={this.state.updated_info} handleClose={this.handleClose}/>
                              )}
                              <div className="card-header">
                                <div className="row">
                                  <div className="col-md-3">
                                    <TextBox
                                      type="Date"
                                      id="from_date"
                                      name="from_date"
                                      label="From Date"
                                      value={this.state.from_date}
                                      change={this.handleInputChange}
                                    />
                                  </div>
                                  <div className="col-md-3">
                                    <TextBox
                                      type="Date"
                                      id="to_date"
                                      name="to_date"
                                      label="To Date"
                                      value={this.state.to_date}
                                      change={this.handleInputChange}
                                    />
                                  </div>
                                  <div className="row mt-3">
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex">
                                        <div className="me-3">
                                            <div>
                                                <label>Apply Filter</label>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={this.handleInputSearch}
                                                className={`btn btn-info btn-label waves-effect waves-light ${(this.state.to_date === '' && this.state.from_date === '') ? 'disabled' : ''}`}>
                                                <i className="ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                Filter
                                            </button>
                                        </div>
                                        <div>
                                            <div>
                                                <label>Clear filter</label>
                                            </div>
                                            <button
                                                type="button"
                                                className={`btn btn-secondary btn-label waves-effect waves-light ${(!this.state.from_date === '' && this.state.to_date === '') ? 'disabled' : ''}`}
                                                onClick={this.handleClearAll}
                                            >
                                                <i className="ri-database-2-line label-icon align-middle fs-16 me-2"></i> Clear
                                            </button>
                                        </div>
                                    </div>
                                    <div className="d-flex">
                                        <div className="me-3">
                                            <div>
                                                <label>Export Excel Download</label>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={this.handleExcelDownload}
                                                className={`${this.state.auditLogs.length === 0 ? ('disabled') : ""} btn btn-success btn-label waves-effect waves-light`}>
                                                <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                Export Excel
                                            </button>
                                        </div>
                                        <div>
                                            <div>
                                                <label>Export CSV Download</label>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={this.handleCSVDownload}
                                                className={`${this.state.auditLogs.length === 0 ? ('disabled') : ""} btn btn-success btn-label waves-effect waves-light`}>
                                                <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                Export CSV 
                                            </button>
                                        </div>
                                    </div>
                                </div>
</div>

                                
                                </div>
                              </div>
                              <div className="card-body">
                                <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                  <table style={{ minwidth: '100%' }} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped text-center">
                                    <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                <tr>
                                    <th>Sr.No.</th>
                                    <th className="noWrap">Entered by Date & Time</th>
                                    <th className="noWrap">Module Name</th>
                                    <th className="noWrap">Form Name</th>
                                    {/* <th className="noWrap">Master / Transaction ID</th> */}
                                    <th className="noWrap">Transaction Type</th>
                                    {/* <th style={{ width: "10%" }}>Previous Information</th>
                                    <th style={{ width: "10%" }}>After Information</th> */}
                                    <th className='noWrap'>
                                     Previous Information
                                    </th>
                                    <th className='noWrap'>
                                    After Information</th>
                                    {/* {Object.keys(updatedFields).map((key, index) => (
                                                <tr key={index}>
                                                    <td>{key}</td>
                                                    <td>{updatedFields[key].old}</td>
                                                    <td>{updatedFields[key].new}</td>
                                                </tr>
                                            ))} */}
                                    <th className="noWrap">Entered by</th>
                                    {/* <th className="noWrap">Action</th> */}
                                    
                                    {/* <th>Modify by</th> */}
                                    {/* <th className="noWrap">Modify by Date & Time</th> */}
                                    {/* <th className='noWrap'>Check by</th>
                                    <th className="noWrap">Check by Date & Time</th> */}
                                </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.auditLogs.length === 0 ? (
                                            <tr>
                                                <td colSpan={13}>
                                                    <NoRecords />
                                                </td>
                                            </tr>
                                        ) : (
                                            this.state.auditLogs.map((log, idx) => {
                                                const safeParse = (data) => {
                                                    if (!data || data === "null" || data === "undefined") return "--";
                                                    try {
                                                        return JSON.parse(data);
                                                    } catch (error) {
                                                        console.error("JSON Parse Error:", error, "Data:", data);
                                                        return "--";
                                                    }
                                                };

                                                const previousInfo = safeParse(log.previouse_information);
                                                const updatedInfo = safeParse(log.updated_information);

                                                return (
                                                    <tr key={log.id || idx}>
                                                      <td className="text-center">{idx + 1}</td>
                                                      {/* <td>{validateDateOnly(log.created_date)}</td> */}
                                                      <td>{formatDateTimeSafe(log.created_date)}</td>

                                                      {/* <td>{log.created_date ? formatDateTime(log.created_date) : "--"}</td> */}
                                                      {/* <td>{formatDateTime(log.created_date)}</td> */}

                                                      <td>{log.module_name || "--"}</td>
                                                      <td>{log.form_name || "--"}</td>
                                                      <td>{log.transaction_type || "--"}</td>
                                                      {/* <td>{previousInfo !== "--" ? JSON.stringify(previousInfo, null, 2) : "--"}</td>
                                                      <td>{updatedInfo !== "--" ? JSON.stringify(updatedInfo, null, 2) : "--"}</td> */}
                                                      <td className={`${JSON.stringify({ ...previousInfo }, null, 2)?.length >= 30 ? "textEllipse" : "noWrap"}`}>{previousInfo !== "--" ? JSON.stringify({ ...previousInfo }, null, 2) : "--"}</td>
                                                      <td className={`${JSON.stringify({ ...updatedInfo }, null, 2)?.length >= 30 ? "textEllipse" : "noWrap"}`}>{updatedInfo !== "--" ? JSON.stringify({ ...updatedInfo }, null, 2) : "--"}</td>
                                                      <td>{log.created_by_name || "--"}</td>
                                                      {/* <td>
                                                        { log?.form_name==="Leave General Settings" ? (
                                                          <div className="d-flex justify-content-around  gap-2">
                                                          <IconButton 
                                                          onClick={() => {
                                                            this.handleShow(`${log.form_name}`,previousInfo,updatedInfo);
                                                          }} type='primary' icon='ri-file-info-line' 
                                                          tooltipName='View Log Info' tooltipPosition='bottom' />
                                                        </div>) : ("--")
                                                        }
                                                      </td> */}
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <div className="d-flex justify-content-between bg-light align-items-center w-100 py-2 px-2">
                                <button
                                  disabled={
                                    this.state.prev === false &&
                                    this.state.loadingList === false
                                      ? true
                                      : false
                                  }
                                  type="button"
                                  onClick={() => this.handlePrev()}
                                  className={`btn btn-warning btn-label waves-effect waves-light`}
                                >
                                  <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                  Previous
                                </button>
                                <div
                                  className="col-md-4"
                                  style={{ display: "flex", alignItems: "center" }}
                                >
                                  {
                                    <small>
                                      Total Records: {this.state.total_records} | Total
                                      Pages: {this.state.total_pages} | Current Page:{" "}
                                      {this.state.page}
                                    </small>
                                  }
                                </div>
                                <div className="col-md-2">
                                  <select
                                    className="form-select"
                                    onChange={(e) => this.handleChange(e)}
                                  >
                                    {Array.from(
                                      { length: this.state.total_pages },
                                      (_, i) => (
                                        <option
                                          selected={this.state.page === i + 1}
                                          key={i}
                                          value={i + 1}
                                        >
                                          Page {i + 1}
                                        </option>
                                      )
                                    )}
                                  </select>
                                </div>
                                <div className="col-md-2">
                                  <select
                                    className="form-select"
                                    onChange={this.handleLimitChange}
                                    value={this.state.limit}
                                  >
                                    {/* {this.state.auditLogs?.length > 0 && (
                                      <option value={this.state.auditLogs?.length}>All</option>
                                    )} */}
                                    {limitOptions.map((option) => (
                                      <option key={option} value={option}>
                                        Limit {option}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <button
                                  disabled={
                                    this.state.next === false &&
                                    this.state.loadingList === false
                                      ? true
                                      : false
                                  }
                                  type="button"
                                  onClick={() => this.handleNext()}
                                  className={`btn btn-primary btn-label waves-effect right waves-light`}
                                >
                                  <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                                  Next
                                </button>
                              </div>
                              </div>
                            </div>
                           
                          </div>
                        </div>
                      </div>
                    </div>
                 
           
        )
    }; 
}
export default withRouter(AllLogs);